// TODO: Use @mui/base instead
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';
import cx from 'classnames';
import { ReactNode } from 'react';
import css from './Tooltip.module.scss';

interface ITooltipProps extends Omit<TooltipProps, 'children'> {
  children: ReactNode;
  childrenClassName?: string;
  disabled?: boolean;
  tabIndex?: number;
}

export const Tooltip = ({
  arrow = true,
  children,
  childrenClassName,
  componentsProps,
  placement = 'bottom',
  disabled = false,
  title,
  tabIndex = 0,
  ...restTooltipProps
}: ITooltipProps) => {
  return (
    <MuiTooltip
      {...restTooltipProps}
      arrow={arrow}
      componentsProps={{
        arrow: {
          ...componentsProps?.arrow,
          className: cx(css.arrow, componentsProps?.arrow?.className),
        },
        tooltip: {
          ...componentsProps?.tooltip,
          className: cx(css.tooltip, componentsProps?.tooltip?.className),
        },
      }}
      placement={placement}
      title={disabled ? undefined : title}
    >
      <div
        className={cx(css.children, childrenClassName, {
          [css.disabled]: disabled,
        })}
        tabIndex={tabIndex}
      >
        {children}
      </div>
    </MuiTooltip>
  );
};
